// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AddShorts.module.css */
.AddShorts_container__hnLwo {
    max-width: 1200px;
    margin: 0 auto;
    padding: 2rem;
    color: #ffffff;
    background-color: #000000;
    min-height: 100vh;
  }
  
  .AddShorts_title__k2fUR {
    color: #ff0000;
    font-size: 2rem;
    margin-bottom: 2rem;
    text-align: center;
  }
  
  .AddShorts_form__035tF {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    background-color: #111111;
    padding: 2rem;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(255, 0, 0, 0.1);
  }
  
  .AddShorts_inputGroup__A2Ua3 {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  
  .AddShorts_inputGroup__A2Ua3 label {
    color: #ff0000;
    font-weight: 500;
  }
  
  .AddShorts_inputGroup__A2Ua3 input,
  .AddShorts_inputGroup__A2Ua3 textarea,
  .AddShorts_inputGroup__A2Ua3 select {
    padding: 0.75rem;
    border: 1px solid #333333;
    border-radius: 4px;
    background-color: #222222;
    color: #ffffff;
    font-size: 1rem;
  }
  
  .AddShorts_inputGroup__A2Ua3 input:focus,
  .AddShorts_inputGroup__A2Ua3 textarea:focus,
  .AddShorts_inputGroup__A2Ua3 select:focus {
    outline: none;
    border-color: #ff0000;
  }
  
  .AddShorts_mediaSection__2Q1If {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 1.5rem;
    margin: 1rem 0;
  }
  
  .AddShorts_uploadBox__wZfwF {
    border: 2px dashed #333333;
    padding: 1rem;
    border-radius: 8px;
    position: relative;
  }
  
  .AddShorts_uploadBox__wZfwF:hover {
    border-color: #ff0000;
  }
  
  .AddShorts_fileInput__vI36y {
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
  
  .AddShorts_uploadPlaceholder__j4XTj {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 200px;
    color: #666666;
  }
  
  .AddShorts_previewContainer__FY9b\\+ {
    position: relative;
    margin-top: 1rem;
  }
  
  .AddShorts_videoPreview__DkKF2,
  .AddShorts_thumbnailPreview__KmLqT {
    width: 100%;
    max-height: 300px;
    object-fit: contain;
    border-radius: 4px;
  }
  
  .AddShorts_removeButton__vQ8qx {
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
    background-color: rgba(255, 0, 0, 0.8);
    color: white;
    border: none;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background-color 0.2s;
  }
  
  .AddShorts_removeButton__vQ8qx:hover {
    background-color: #ff0000;
  }
  
  .AddShorts_checkboxGroup__-Ip1\\+ {
    display: flex;
    gap: 1rem;
    margin: 1rem 0;
  }
  
  .AddShorts_checkboxGroup__-Ip1\\+ label {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    cursor: pointer;
  }
  
  
.AddShorts_buttonGroup__8ztiw {
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
}

.AddShorts_submitButton__jtbXE {
  background-color: red;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 0.8rem 1.5rem;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.AddShorts_submitButton__jtbXE:hover {
  background-color: rgb(225, 73, 73);
}

.AddShorts_submitButton__jtbXE:disabled {
  background-color: #a5c2ff;
  cursor: not-allowed;
}

.AddShorts_cancelButton__-GXJi {
  background-color: #e0e0e0;
  color: #333;
  border: none;
  border-radius: 4px;
  padding: 0.8rem 1.5rem;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.AddShorts_cancelButton__-GXJi:hover {
  background-color: #d0d0d0;
}

.AddShorts_loading__2S7ov {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
  font-size: 1.2rem;
  color: #666;
}

.AddShorts_noteText__nHfvJ {
  font-size: 0.85rem;
  color: #666;
  margin-top: 0.5rem;
  font-style: italic;
}
  
  @media (max-width: 768px) {
    .AddShorts_container__hnLwo {
      padding: 1rem;
    }
    
    .AddShorts_form__035tF {
      padding: 1rem;
    }
    
    .AddShorts_checkboxGroup__-Ip1\\+ {
      flex-direction: column;
    }
  }`, "",{"version":3,"sources":["webpack://./src/admin/pages/shorts/AddShorts.module.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,cAAc;IACd,yBAAyB;IACzB,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,0CAA0C;EAC5C;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;;;IAGE,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,eAAe;EACjB;;EAEA;;;IAGE,aAAa;IACb,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,2DAA2D;IAC3D,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,0BAA0B;IAC1B,aAAa;IACb,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,UAAU;IACV,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;;IAEE,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,sCAAsC;IACtC,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,eAAe;EACjB;;;AAGF;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;EAEE;IACE;MACE,aAAa;IACf;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,sBAAsB;IACxB;EACF","sourcesContent":["/* AddShorts.module.css */\n.container {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 2rem;\n    color: #ffffff;\n    background-color: #000000;\n    min-height: 100vh;\n  }\n  \n  .title {\n    color: #ff0000;\n    font-size: 2rem;\n    margin-bottom: 2rem;\n    text-align: center;\n  }\n  \n  .form {\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n    background-color: #111111;\n    padding: 2rem;\n    border-radius: 8px;\n    box-shadow: 0 4px 6px rgba(255, 0, 0, 0.1);\n  }\n  \n  .inputGroup {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n  \n  .inputGroup label {\n    color: #ff0000;\n    font-weight: 500;\n  }\n  \n  .inputGroup input,\n  .inputGroup textarea,\n  .inputGroup select {\n    padding: 0.75rem;\n    border: 1px solid #333333;\n    border-radius: 4px;\n    background-color: #222222;\n    color: #ffffff;\n    font-size: 1rem;\n  }\n  \n  .inputGroup input:focus,\n  .inputGroup textarea:focus,\n  .inputGroup select:focus {\n    outline: none;\n    border-color: #ff0000;\n  }\n  \n  .mediaSection {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n    gap: 1.5rem;\n    margin: 1rem 0;\n  }\n  \n  .uploadBox {\n    border: 2px dashed #333333;\n    padding: 1rem;\n    border-radius: 8px;\n    position: relative;\n  }\n  \n  .uploadBox:hover {\n    border-color: #ff0000;\n  }\n  \n  .fileInput {\n    opacity: 0;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    cursor: pointer;\n  }\n  \n  .uploadPlaceholder {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    min-height: 200px;\n    color: #666666;\n  }\n  \n  .previewContainer {\n    position: relative;\n    margin-top: 1rem;\n  }\n  \n  .videoPreview,\n  .thumbnailPreview {\n    width: 100%;\n    max-height: 300px;\n    object-fit: contain;\n    border-radius: 4px;\n  }\n  \n  .removeButton {\n    position: absolute;\n    top: 0.5rem;\n    right: 0.5rem;\n    background-color: rgba(255, 0, 0, 0.8);\n    color: white;\n    border: none;\n    border-radius: 50%;\n    width: 30px;\n    height: 30px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: background-color 0.2s;\n  }\n  \n  .removeButton:hover {\n    background-color: #ff0000;\n  }\n  \n  .checkboxGroup {\n    display: flex;\n    gap: 1rem;\n    margin: 1rem 0;\n  }\n  \n  .checkboxGroup label {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    cursor: pointer;\n  }\n  \n  \n.buttonGroup {\n  display: flex;\n  gap: 1rem;\n  margin-top: 1rem;\n}\n\n.submitButton {\n  background-color: red;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 0.8rem 1.5rem;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.submitButton:hover {\n  background-color: rgb(225, 73, 73);\n}\n\n.submitButton:disabled {\n  background-color: #a5c2ff;\n  cursor: not-allowed;\n}\n\n.cancelButton {\n  background-color: #e0e0e0;\n  color: #333;\n  border: none;\n  border-radius: 4px;\n  padding: 0.8rem 1.5rem;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.cancelButton:hover {\n  background-color: #d0d0d0;\n}\n\n.loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 300px;\n  font-size: 1.2rem;\n  color: #666;\n}\n\n.noteText {\n  font-size: 0.85rem;\n  color: #666;\n  margin-top: 0.5rem;\n  font-style: italic;\n}\n  \n  @media (max-width: 768px) {\n    .container {\n      padding: 1rem;\n    }\n    \n    .form {\n      padding: 1rem;\n    }\n    \n    .checkboxGroup {\n      flex-direction: column;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AddShorts_container__hnLwo`,
	"title": `AddShorts_title__k2fUR`,
	"form": `AddShorts_form__035tF`,
	"inputGroup": `AddShorts_inputGroup__A2Ua3`,
	"mediaSection": `AddShorts_mediaSection__2Q1If`,
	"uploadBox": `AddShorts_uploadBox__wZfwF`,
	"fileInput": `AddShorts_fileInput__vI36y`,
	"uploadPlaceholder": `AddShorts_uploadPlaceholder__j4XTj`,
	"previewContainer": `AddShorts_previewContainer__FY9b+`,
	"videoPreview": `AddShorts_videoPreview__DkKF2`,
	"thumbnailPreview": `AddShorts_thumbnailPreview__KmLqT`,
	"removeButton": `AddShorts_removeButton__vQ8qx`,
	"checkboxGroup": `AddShorts_checkboxGroup__-Ip1+`,
	"buttonGroup": `AddShorts_buttonGroup__8ztiw`,
	"submitButton": `AddShorts_submitButton__jtbXE`,
	"cancelButton": `AddShorts_cancelButton__-GXJi`,
	"loading": `AddShorts_loading__2S7ov`,
	"noteText": `AddShorts_noteText__nHfvJ`
};
export default ___CSS_LOADER_EXPORT___;
